import { useEffect } from 'react'
import ShowAlumni from '../showAlumni'
import { Alignment, Fit, Layout, useRive } from '@rive-app/react-canvas'
const AlumniMap = () => {
  const map = '/assets/map.svg'
  const { rive, RiveComponent } = useRive({
    src: '/assets/map_uniten.riv',
    autoplay: true,
    layout: new Layout({
      fit: Fit.Cover,
      alignment: Alignment.Center
    }),
    onStop: () => {
      // Restart the animation when it stops
      rive && rive.play()
    }
  })
  

  return (
    <div className='w-full  flex flex-col gap-6 relative'>
      {/* <div
        className='w-full h-[30rem] 2xl:h-screen 2xl:bg-cover  overflow-hidden bg-contain bg-no-repeat bg-center'
        style={{ backgroundImage: `url('${map}')` }}
      ></div> */}
      {/* <ShowAlumni /> */}

      <div className=' min-w-screen relative min-h-[50vw] lg:min-h-screen object-cover w-full h-full'>
        <RiveComponent
          className='absolute inset-0 grid place-items-center loading [&>canvas]:!w-full [&>canvas]:!h-full'
          style={{ width: '100%', height: '100%' }}
        />
      </div>
    </div>
  )
}

export default AlumniMap
